/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdmissionStatus } from './AdmissionStatus';
import {
    AdmissionStatusFromJSON,
    AdmissionStatusFromJSONTyped,
    AdmissionStatusToJSON,
    AdmissionStatusToJSONTyped,
} from './AdmissionStatus';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus';

/**
 * 
 * @export
 * @interface InstanceBulkActionLead
 */
export interface InstanceBulkActionLead {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_name?: string;
    /**
     * 
     */
    source_name?: string;
    /**
     * 
     */
    lead_received_date: string;
    /**
     * 
     */
    screener_suggestion?: InstanceBulkActionLeadScreenerSuggestionEnum;
    /**
     * 
     */
    ai_suggestion?: InstanceBulkActionLeadAiSuggestionEnum;
    /**
     * 
     */
    status?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus;
    /**
     * 
     */
    auto_accepted_by_ai?: boolean;
    /**
     * 
     * @deprecated
     */
    admission_status?: AdmissionStatus;
    /**
     * 
     */
    connector: string;
}


/**
 * @export
 */
export const InstanceBulkActionLeadScreenerSuggestionEnum = {
    Accept: 'Accept',
    Reject: 'Reject',
    Maybe: 'Maybe',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    NA: 'N/A',
} as const;
export type InstanceBulkActionLeadScreenerSuggestionEnum = typeof InstanceBulkActionLeadScreenerSuggestionEnum[keyof typeof InstanceBulkActionLeadScreenerSuggestionEnum];

/**
 * @export
 */
export const InstanceBulkActionLeadAiSuggestionEnum = {
    Accept: 'Accept',
    Reject: 'Reject',
    Maybe: 'Maybe',
    Pending: 'Pending',
    Cancelled: 'Cancelled',
    NA: 'N/A',
} as const;
export type InstanceBulkActionLeadAiSuggestionEnum = typeof InstanceBulkActionLeadAiSuggestionEnum[keyof typeof InstanceBulkActionLeadAiSuggestionEnum];


/**
 * Check if a given object implements the InstanceBulkActionLead interface.
 */
export function instanceOfInstanceBulkActionLead(value: object): value is InstanceBulkActionLead {
    if (!('lead_received_date' in value) || value['lead_received_date'] === undefined) return false;
    if (!('connector' in value) || value['connector'] === undefined) return false;
    return true;
}

export function InstanceBulkActionLeadFromJSON(json: any): InstanceBulkActionLead {
    return InstanceBulkActionLeadFromJSONTyped(json, false);
}

export function InstanceBulkActionLeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkActionLead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_name': json['facility_name'] == null ? undefined : json['facility_name'],
        'source_name': json['source_name'] == null ? undefined : json['source_name'],
        'lead_received_date': json['lead_received_date'],
        'screener_suggestion': json['screener_suggestion'] == null ? undefined : json['screener_suggestion'],
        'ai_suggestion': json['ai_suggestion'] == null ? undefined : json['ai_suggestion'],
        'status': json['status'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSON(json['status']),
        'auto_accepted_by_ai': json['auto_accepted_by_ai'] == null ? undefined : json['auto_accepted_by_ai'],
        'admission_status': json['admission_status'] == null ? undefined : AdmissionStatusFromJSON(json['admission_status']),
        'connector': json['connector'],
    };
}

export function InstanceBulkActionLeadToJSON(json: any): InstanceBulkActionLead {
    return InstanceBulkActionLeadToJSONTyped(json, false);
}

export function InstanceBulkActionLeadToJSONTyped(value?: InstanceBulkActionLead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_name': value['facility_name'],
        'source_name': value['source_name'],
        'lead_received_date': value['lead_received_date'],
        'screener_suggestion': value['screener_suggestion'],
        'ai_suggestion': value['ai_suggestion'],
        'status': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusToJSON(value['status']),
        'auto_accepted_by_ai': value['auto_accepted_by_ai'],
        'admission_status': AdmissionStatusToJSON(value['admission_status']),
        'connector': value['connector'],
    };
}

